(function () {
  'use strict';

  function init(root) {
    root.querySelectorAll('[data-uc-shop-results]').forEach(function (section) {
      if (section.dataset.ucShopReady === 'true') return;
      section.dataset.ucShopReady = 'true';

      var videos = Array.prototype.slice.call(section.querySelectorAll('.uc-shop-card__video'));
      var modal = section.querySelector('[data-uc-shop-modal]');
      var panels = modal ? Array.prototype.slice.call(modal.querySelectorAll('[data-uc-shop-panel]')) : [];
      var activeVideo = 0;
      var activePanel = 0;
      var sectionVisible = false;
      var lastFocus = null;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function pauseVideos() {
        videos.forEach(function (video) {
          video.pause();
          var card = video.closest('[data-uc-shop-card]');
          if (card) card.classList.remove('is-playing');
        });
      }

      function playVideo(index, restart) {
        if (!videos.length || reducedMotion || !sectionVisible) return;
        if (modal && !modal.hidden) return;

        activeVideo = (index + videos.length) % videos.length;
        pauseVideos();

        var video = videos[activeVideo];
        if (restart || video.ended) video.currentTime = 0;
        video.muted = true;
        video.playsInline = true;

        var card = video.closest('[data-uc-shop-card]');
        if (card) card.classList.add('is-playing');

        var promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {
            if (card) card.classList.remove('is-playing');
          });
        }
      }

      videos.forEach(function (video, index) {
        video.loop = false;
        video.muted = true;
        video.playsInline = true;
        video.removeAttribute('autoplay');

        video.addEventListener('ended', function () {
          if (index !== activeVideo) return;
          playVideo((index + 1) % videos.length, true);
        });
      });

      if (videos.length && !reducedMotion && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            sectionVisible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
            if (sectionVisible) {
              playVideo(activeVideo, videos[activeVideo].ended);
            } else {
              pauseVideos();
            }
          });
        }, { threshold: [0, 0.15, 0.4] });

        observer.observe(section);
      } else if (videos.length && !reducedMotion) {
        sectionVisible = true;
        playVideo(0, true);
      }

      function showPanel(index) {
        if (!panels.length) return;
        activePanel = (index + panels.length) % panels.length;

        panels.forEach(function (panel, panelIndex) {
          panel.hidden = panelIndex !== activePanel;
        });

        var productArea = panels[activePanel].querySelector('.uc-shop-modal__products');
        if (productArea) productArea.scrollTop = 0;
      }

      function openModal(index, trigger) {
        if (!modal || !panels.length) return;
        lastFocus = trigger || document.activeElement;
        pauseVideos();
        showPanel(index);
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('uc-shop-modal-open');

        var closeButton = modal.querySelector('.uc-shop-modal__close');
        if (closeButton) window.setTimeout(function () { closeButton.focus(); }, 0);
      }

      function closeModal() {
        if (!modal || modal.hidden) return;
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('uc-shop-modal-open');

        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        if (sectionVisible) playVideo(activeVideo, false);
      }

      section.querySelectorAll('[data-uc-shop-open]').forEach(function (button) {
        button.addEventListener('click', function () {
          openModal(parseInt(button.dataset.ucShopOpen, 10) || 0, button);
        });
      });

      if (modal) {
        modal.querySelectorAll('[data-uc-shop-close]').forEach(function (button) {
          button.addEventListener('click', closeModal);
        });

        var previous = modal.querySelector('[data-uc-shop-previous]');
        var next = modal.querySelector('[data-uc-shop-next]');

        if (previous) previous.addEventListener('click', function () { showPanel(activePanel - 1); });
        if (next) next.addEventListener('click', function () { showPanel(activePanel + 1); });

        modal.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeModal();
            return;
          }

          if (event.key !== 'Tab') return;
          var focusable = Array.prototype.slice.call(
            modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
          ).filter(function (element) {
            return !element.closest('[hidden]');
          });

          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          pauseVideos();
        } else if (sectionVisible && (!modal || modal.hidden)) {
          playVideo(activeVideo, false);
        }
      });
    });
  }

  if (window.UCShopResultsV2) {
    window.UCShopResultsV2.init(document);
    return;
  }

  window.UCShopResultsV2 = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
